import { render } from "./ToastMessages.vue?vue&type=template&id=4f837680"
import script from "./ToastMessages.vue?vue&type=script&lang=js"
export * from "./ToastMessages.vue?vue&type=script&lang=js"
script.render = render

export default script